import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

async function loadPdf(source) {
    const data = new Uint8Array(await source.arrayBuffer());
    try {
        return await pdfjsLib.getDocument({ data }).promise;
    } catch (err) {
        if (String(err?.message || '').toLowerCase().includes('password')) {
            throw new Error('password');
        }
        throw err;
    }
}

async function renderPageThumbnail(pdf, pageNumber, { thumbWidth, thumbHeight } = {}) {
    const page = await pdf.getPage(pageNumber);
    const baseViewport = page.getViewport({ scale: 1 });
    const scale = thumbWidth
        ? thumbWidth / baseViewport.width
        : (thumbHeight || 220) / baseViewport.height;
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.floor(viewport.width));
    canvas.height = Math.max(1, Math.floor(viewport.height));
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    await page.render({ canvasContext: ctx, viewport, background: '#ffffff' }).promise;
    return {
        src: canvas.toDataURL('image/jpeg', 0.82),
        pdfWidth: baseViewport.width,
        pdfHeight: baseViewport.height,
        renderWidth: canvas.width,
        renderHeight: canvas.height,
    };
}

/**
 * Render PDF pages as JPEG thumbnails (canvas-based, not iframe).
 * @param {File|Blob} source
 * @param {{ maxPages?: number, thumbWidth?: number, thumbHeight?: number, onPage?: (page: { pageNumber: number, src: string, total: number, pdfWidth?: number, pdfHeight?: number }) => void }} [options]
 */
export async function renderPdfPageThumbnails(source, options = {}) {
    const { maxPages = 40, thumbWidth, thumbHeight = 220, onPage } = options;
    const pdf = await loadPdf(source);
    const total = pdf.numPages;
    const count = Math.min(total, maxPages);
    const pages = [];

    for (let pageNumber = 1; pageNumber <= count; pageNumber += 1) {
        const thumb = await renderPageThumbnail(pdf, pageNumber, { thumbWidth, thumbHeight });
        const page = { pageNumber, total, ...thumb };
        pages.push(page);
        onPage?.(page);
    }

    return pages;
}
